import {Box, Paper, Typography} from "@mui/material";

interface Props {
    icon: React.ReactNode;
    label: string;
}

// dnd element for tables or elements on mobile (it's smaller)
const PreviewDropTableElementMobile: React.FC<Props> = ({icon, label}) => {
    return (
        <Paper
            elevation={8}
            sx={{
                px: 1.25,
                py: 1,
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                borderRadius: 2,
                maxWidth: 164,
                bgcolor: 'background.paper',
                opacity: 0.96,
            }}
        >
            <Box
                sx={{
                    width: 32,
                    height: 32,
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 1,
                    bgcolor: 'grey.100',
                    color: 'text.secondary',
                }}
            >
                {icon}
            </Box>
            <Typography
                fontSize="0.8125rem"
                fontWeight={600}
                noWrap
            >
                {label}
            </Typography>
        </Paper>
    );
};

export default PreviewDropTableElementMobile;
